<template>
  <div class="login">
    <!-- <div class="announcement" v-show="showAnnouncement && !accessAccount.includes(name)">
      <i class="announcement-close" style="position: absolute; right: 10px;top: 10px;cursor: pointer;" @click="handleClose">
        <svg t="1650616829224" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3758" width="20" height="20"><path d="M585.412525 512.594747L973.601616 124.418586c19.600808-19.600808 19.600808-51.898182 0-71.49899l-2.120404-2.120404c-19.600808-19.600808-51.898182-19.600808-71.49899 0L511.793131 439.518384 123.61697 50.799192c-19.600808-19.600808-51.898182-19.600808-71.49899 0l-2.120404 2.120404c-20.11798 19.600808-20.11798 51.898182 0 71.49899l388.189091 388.189091L49.997576 900.783838c-19.587879 19.600808-19.587879 51.898182 0 71.49899l2.120404 2.120404c19.600808 19.600808 51.898182 19.600808 71.49899 0L511.793131 586.214141l388.189091 388.176162c19.600808 19.600808 51.898182 19.600808 71.49899 0l2.120404-2.120404c19.600808-19.600808 19.600808-51.898182 0-71.49899L585.412525 512.594747z m0 0" p-id="3759" fill="#303333"></path></svg>
      </i>
      <h2>
        <svg t="1650615888061" class="icon" viewBox="0 0 1261 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1285" width="30" height="30"><path d="M1147.133 460.907l-213.577 0c-24.231 0-43.857 19.731-43.857 44.031l0 13.743c0 24.335 19.627 44.031 43.857 44.031l213.577 0c24.231 0 43.857-19.696 43.857-44.031l0-13.743c0-24.3-19.627-44.031-43.857-44.031zM651.579 83.011c-66.427 52.823-205.443 126.865-305.481 198.035l-0.139 0.069c-1.143 0.693-2.285 4.639-3.427 5.296-11.839 6.646-17.135 25.027-81.381 25.027l-125.343 0c-32.157 0-52.131 15.057-52.131 49.015l0 301.846c0 33.957 18.311 50.711 52.131 50.711l125.861 0c63.935 0.104 69.127 18.346 80.896 24.993 1.143 0.657 2.25 4.604 3.427 5.296l0.139 0.069c96.889 71.169 236.839 150.993 305.481 201.635 20.665 15.265 89.411 42.093 89.411-52.235 0-111.011 0-651.427 0-761.539 0-94.361-69.3-64.211-89.446-48.219zM848.818 291.119c11.354 20.007 33.819 25.027 50.227 11.215l175.569-147.981c16.407-13.811 20.493-41.227 9.173-61.269l-6.439-11.319c-11.319-20.007-33.819-25.027-50.193-11.215l-175.569 147.946c-16.407 13.846-20.527 41.261-9.173 61.269l6.404 11.354zM899.01 722.046c-16.407-13.811-38.873-8.793-50.227 11.181l-6.404 11.319c-11.354 20.007-7.2 47.423 9.173 61.269l175.569 147.946c16.407 13.811 38.873 8.793 50.193-11.181l6.439-11.319c11.319-20.007 7.2-47.423-9.173-61.269l-175.569-147.946z" p-id="1286" fill="#f4ea2a"></path></svg>
        <span>ISSUE登录提示</span>
      </h2>
      <p>【系统升级】ISSUE将于4月22日晚上8时暂停登录，并于4月25日下午2时恢复，敬请原谅！</p>
      <div class="announcement-close know-close" @click="handleClose">知道了</div>
    </div> -->
    <page-header class="page-header-index"></page-header>
    <div class="header">
      <img class="logo" src="../assets/img/issue.png" alt="logo">
      <span class="text">{{header_text}}</span>
    </div>
    <div class="form-content">
      <div class="form-box">
        <div class="form-title">
          <h2>{{$t('form_text')}}</h2>
        </div>
        <div class="form-input">
          <input class="name" v-model.trim="name" type="text" :placeholder="$t('mail_phone')">
          <input class="pwd" v-model.trim="pwd" type="password" :placeholder="$t('password')">
        </div>
        <button type="button" class="sub-btn" @click="doAjax">{{$t('login_btn')}}</button>
        <div class="link-box">
          <a href="#" @click="toForget">{{$t('forget')}}</a>
          <a href="#" @click="toRegister">{{$t('register')}}</a>
        </div>
      </div>
    </div>
    <div class='copyright'><span style='margin-right:15px;'>© Powered By Global Education Alliance Ltd. 2009-{{nowYear}} All Rights Reserved 锆德教育资讯（深圳）有限公司 版权所有</span><a id="beina" target="_blank" href="http://beian.miit.gov.cn">粤ICP备17124843号</a></div>
  </div>
</template>

<script>
// import i18n from 'vue-i18n'
import {setCookie, getCookie} from '@/util/cookie.js'
import PageHeader from '../components/PageHeader.vue'
export default{
  name: 'Login',
  components: {
    PageHeader
  },
  computed: {
    nowYear () {
      const year = new Date()
      return year.getFullYear()
    }
  },
  data () {
    return {
      tooken: '',
      header_text: 'iSSUE 一休',
      form_text: 'Agency Sign In',
      btn_name: 'SIGN IN',
      name: '',
      pwd: ''
      // showAnnouncement: false,
      // accessAccount: ['13580402653']
    }
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    let id = sessionStorage.getItem('id')
    let cookie = getCookie('token')
    if (id && cookie) {
      next({ path: 'detail', query: {'id': id} })
    } else {
      next()
    }
  },
  methods: {
    // handleClose () {
    //   this.showAnnouncement = false
    // },
    doAjax () {
      // if (!this.accessAccount.includes(this.name)) {
      //   this.showAnnouncement = true
      //   return
      // }
      let _this = this
      let username = this.name
      let password = this.pwd
      this.$axios({
        method: 'post',
        url: '/stu_appl/applAgLogin',
        data: _this.$qs.stringify({ username: username, password: password })
      }).then(res => {
        _this.$nextTick(() => {
          let token = res.data.token
          let state = res.data.state
          if (token === '' && state === 'error') {
            confirm(this.$t('checkAccount'))
            // _this.reload()
          } else {
            // _this.$cookieStore.setCookie('token', token)
            setCookie('token', token)
            window.location.href = '/stu_appl/index.jsp'
          }
        })
      }).catch(err => {
        _this.$nextTick(() => {
          console.log(err, '错误')
          _this.reload()
        })
      })
    },
    toForget () {
      window.location.href = '/agent_pc/agency_reset.jsp'
    },
    toRegister () {
      window.location.href = '/agent_pc/register.jsp'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .login
    height 100%
    position absolute
    left 0
    top 0
    right 0
    bottom 0
    background: url('../assets/img/banner2.jpg') no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: cover;
    -webkit-background-size: cover;
  .header
    text-align center
    height 100px
    margin-top 50px
    font-size 40px
    color #ffffff
    .logo
      height 50px
      width 50px
    .text
      vertical-align middle
  .copyright
    position absolute
    bottom 10vh
    text-align center
    width 100%
    color #ffffff;
    font-size 10px
    a,a:visited
      color #ffffff;
      text-decoration underline
  .form-content
    height 380px
    width 75%
    margin 0 auto
    .form-box
      background rgba(0,0,0,.35)
      width 48%
      height 380px
      margin 0 auto
      .form-title
        text-align center
        line-height 80px
        font-size 40px
        padding-top 20px
        color #ffffff
        font-family: 'Nunito', sans-serif;
        font-weight 300
      .form-input
        padding 0px 30px
        .name,.pwd
          display block
          width 95%
          line-height 32px
          margin 30px 0
          padding 5px 10px
          outline none
          border-radius 4px
          -webkit-appearance textfield
          border 0
          border 1px solid #fff
          color #ffffff
          font-size 16px
          background-color transparent
        input::-webkit-input-placeholder
          color #ffffff
      .sub-btn
        display block
        border 0
        outline none
        line-height 40px
        width 180px
        margin 30px auto 15px
        font-size 20px
        border-radius 4px
        background-color #009688
        color #ffffff
      .link-box
        text-align center
      .link-box a
        padding 0 4%
        color #ffffff
        font-size 15px
</style>
<style>
  .announcement {
    position: absolute;
    z-index: 100000;
    top: 20%;
    left: 50%;
    margin-left: -200px;
    background: #fefbec;
    width: 460px;
    padding: 30px;
    text-align: left;
    color: #303333;
    border: 1px solid #f4ea2a;
    border-radius: 6px;
  }
  .announcement h2 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  .announcement h2 svg {
    vertical-align: middle;
    margin-top: -3px;
    margin-right: 3px;
  }
  .announcement p {
    font-size: 18px;
    line-height: 1.5;
    margin-bottom: 18px;
  }
  .announcement .know-close {
    width: 100px;
    margin: 0 auto;
    text-align: center;
    padding: 4px;
    color: #fff;
    background-color: #f39c12;
    border-radius: 3px;
    font-size: 18px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue